import { createAction } from '@reduxjs/toolkit';
export const CHANGE_SPEAKER_VOLUME = 'CHANGE_SPEAKER_VOLUME';
export const changeSpeakerVolumeAction = createAction(CHANGE_SPEAKER_VOLUME);

export const CHANGE_NOTIFICATION_VOLUME = 'CHANGE_NOTIFICATION_VOLUME';
export const changeNotificationVolumeAction = createAction(CHANGE_NOTIFICATION_VOLUME);